import {Injectable} from '@angular/core';
import {AngularFireDatabase, AngularFireObject, DatabaseReference,} from 'angularfire2/database';
import {AngularFireList} from 'angularfire2/database/interfaces';
import {Constants} from '../config/Constants';
import {EventTheme} from '../models/event-theme';
import {Observable} from 'rxjs/Observable';
import {UtilityService} from './utility.service';

@Injectable()
export class ThemeService {

  constructor(private basicdb: AngularFireDatabase, private utilityService: UtilityService) {
  }

  THEME_PREF_PATH = '/' + Constants.PREDERENCES_URL + Constants.PREF_THEME;

  getEventTheme(eventId): Observable<EventTheme> {
    // let email = this.utilityService.getUserEmail().replace(/\./g, ',');
    console.log(Constants.EVENT_URL + '/' + eventId);
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<EventTheme> = this.basicdb.object(Constants.EVENT_URL + '/' + eventId + this.THEME_PREF_PATH);
      return data.valueChanges();
    }
    return null;
  }

  updateEventTheme(eventsTheme: EventTheme, eventID: string): Promise<any> {
    return this.basicdb.object(Constants.EVENT_URL + '/' + eventID + this.THEME_PREF_PATH)
      .update(eventsTheme);
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/services/theme.service.ts